import React, { useState, useEffect } from "react";
import { ICONEX } from "src/constants/images";
import { nFormatter } from "utils/nFormatter";
import SkeletonElement from "components/Loader/Skeleton/BasicSkeleton/SkeletonElement";
import * as api from "api/api";

export default function StatsContainer({
  transactionAnalytics,
  isLoading,
  totalTx,
}) {
  const [craftVolumeTraded, setcraftVolumeTraded] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const craft_volume = await api.getVolumeTradedInCraft();
        const volume_traded =
          craft_volume.data.data.primary_asset_contracts.overallStat
            .cx0000000000000000000000000000000000000000.volume;
        setcraftVolumeTraded(volume_traded);
      } catch (e) {
        setcraftVolumeTraded(0);
      }
    })();
  }, []);

  return (
    <div className="stats-container">
      {" "}
      {isLoading ? (
        <>
          <div className="owners">
            <SkeletonElement type="text w-100 me-10" />
            <SkeletonElement type="text w-100 me-10" />
          </div>
        </>
      ) : (
        <>
          {/* <div className="owners">
            <div className="title">Owners </div>
            <div className="stats-value">
              {nFormatter(transactionAnalytics?.gangsta_marketplace?.owners)}
            </div>
          </div> */}
          <div className="owners">
            <div className="title">Transactions </div>
            <div className="stats-value">{nFormatter(totalTx)}</div>
          </div>
        </>
      )}
      <div className="price floor-price">
        <div>
          {isLoading ? (
            <>
              <SkeletonElement type="text w-100 me-10" />
              <SkeletonElement type="text w-100 me-10" />
            </>
          ) : (
            <>
              <div className="title">Floor price </div>
              <div className="stats-value">
                <img src={ICONEX.SOURCE} />
                {nFormatter(
                  transactionAnalytics?.gangsta_marketplace?.floor_price
                )}
                <span className="unit-icx"> ICX</span>
              </div>
            </>
          )}{" "}
        </div>
      </div>{" "}
      <div className="price highest-trade">
        <div>
          {isLoading ? (
            <>
              <SkeletonElement type="text w-100 me-10" />
              <SkeletonElement type="text w-100 me-10" />
            </>
          ) : (
            <>
              <div className="title">Highest Trade </div>
              <div className="stats-value">
                <img src={ICONEX.SOURCE} />
                {nFormatter(
                  transactionAnalytics?.gangsta_marketplace?.highest_trade
                )}
                {/* 20K */}
                <span className="unit-icx"> ICX</span>
              </div>
            </>
          )}{" "}
        </div>
      </div>{" "}
      <div className="price volume-traded">
        <div>
          {isLoading ? (
            <>
              <SkeletonElement type="text w-100 me-10" />
              <SkeletonElement type="text w-100 me-10" />
            </>
          ) : (
            <>
              <div className="title">Volume Traded </div>
              <div className="activity-tooltip">
                <div className="activity-tt">
                  Volume traded in 24 hours (excl. Craft):&nbsp;
                  {nFormatter(
                    transactionAnalytics?.gangsta_marketplace?.volume_traded_24h
                  )}{" "}
                  ICX
                  <br />
                  Volume traded in a week (excl. Craft):&nbsp;
                  {nFormatter(
                    transactionAnalytics?.gangsta_marketplace?.volume_traded_7d
                  )}{" "}
                  ICX
                </div>

                <div className="stats-value">
                  <img src={ICONEX.SOURCE} />
                  {nFormatter(
                    transactionAnalytics?.gangsta_marketplace
                      ?.total_volume_traded + craftVolumeTraded
                  )}
                  <span className="unit-icx"> ICX</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
